import {
  getAgentVersionReport,
  getEpcsAuditReport,
  getLoginActivityReport,
  getUserEnrollmentReport,
} from '@api/portalServices';
import type { EpcsAuditReportGetRequest, LoginActivityReportGetRequest } from '@api/types';
import { useMutation } from '@tanstack/react-query';

export const useLoginActivityReport = () => {
  return useMutation<Blob, Error, LoginActivityReportGetRequest>({
    mutationFn: async request => {
      return getLoginActivityReport(request);
    },
  });
};

export const useEpcsActivityReport = () => {
  return useMutation<Blob, Error, EpcsAuditReportGetRequest>({
    mutationFn: async request => {
      return getEpcsAuditReport(request);
    },
  });
};

export const useAgentVersionReport = () => {
  return useMutation<Blob>({
    mutationFn: async () => {
      return getAgentVersionReport();
    },
  });
};

export const useUserEnrollmentReport = () => {
  return useMutation<Blob>({
    mutationFn: async () => {
      return getUserEnrollmentReport();
    },
  });
};
